<div class="appContentsContainer">
  <div
    id="mantenimientoContainer"
    class="backgroundSand container fullWidthContainer listPage smallTables"
  >
    <div class="pageTitle mb-1 mt-1">
      {{ "placaQuery.titleList" | translate }}
    </div>

    <div
      class="pageTitle collapsibleTitle"
      [ngStyle]="{ 'margin-bottom': !filterTramite ? '57px' : '' }"
    >
      <div class="collapseButtonContainer">
        <button
          *ngIf="!filterTramite"
          class="submitSearchButton"
          (click)="filterTramite = !filterTramite"
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          *ngIf="filterTramite"
          class="submitSearchButton"
          (click)="filterTramite = !filterTramite"
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <h5>En trámite</h5>
      </div>
    </div>

    <div
      [hidden]="!filterTramite"
      class="collapsibleContainer"
      [ngClass]="{
        smaller: filterHistorico,
        expanded: !filterHistorico
      }"
    >
      <div class="filterTableContainer">
        <app-filters
          #outTable
          [filterList]="filterListOutTable"
          [options]="optionsFiltersOutTable"
          [type]="'consulta'"
          class="consultaOutFilters"
          (showfilterButtons)="toggleFilterButtons($event)"
          (showFilters)="showFilters($event)"
        ></app-filters>
        <app-filters
          #insideTable
          [filterList]="filterList"
          [options]="optionsMailBox"
          [ngClass]="{ filterHidden: !showTableFilter }"
          class="inTableFilter"
          (showFilters)="showFilters($event)"
        ></app-filters>
        <app-table
          #placa
          [tableList]="tableList"
          [elementList]="placaList"
          [routing]="routingMailBox"
          [numPages]="numPages"
          [numElements]="numElements"
          [totalElements]="totalElements"
          [filterParams]="filtersTableJSON"
          [options]="optionsMailBox"
          [showFilterButtons]="showFilterButtons"
          (valueFilterTable)="filterTable($event)"
          (headerButtonsActionEvent)="buttonsHeader($event)"
        ></app-table>
      </div>
    </div>

    <div class="pageTitle collapsibleTitle">
      <div class="collapseButtonContainer">
        <button
          *ngIf="!filterHistorico"
          class="submitSearchButton"
          (click)="filterHistorico = !filterHistorico"
        >
          <em class="fas fa-angle-up"></em>
        </button>
        <button
          *ngIf="filterHistorico"
          class="submitSearchButton"
          (click)="filterHistorico = !filterHistorico"
        >
          <em class="fas fa-angle-down"></em>
        </button>
        <h5>Histórico</h5>
      </div>
    </div>
    <div
      [hidden]="!filterHistorico"
      class="collapsibleContainer"
      [ngClass]="{
        smaller: filterTramite,
        expanded: !filterTramite
      }"
    >
      <div class="noFilterTableContainer">
        <app-table
          class="secondTable tableExtraSpaceForEditButtonInFilter"
          #placaHistory
          [tableList]="tableList"
          [elementList]="placaHistoryList"
          [routing]="routingHistory"
          [numPages]="numPagesHistory"
          [numElements]="numElementsHistory"
          [totalElements]="totalElementsHistory"
          [filterParams]="filtersTableHistoryJSON"
          [options]="optionsHistory"
          (valueFilterTable)="filterTableHistory($event)"
        ></app-table>

        <div
          *appPermsRoles="[
            roles.ADMIN,
            roles.ANALISTA,
            roles.AAVANZA,
            roles.REVISOR,
            roles.RHOMOLOG
          ]"
        >
          <button
            class="btnGeneratePrintFile"
            type="button"
            (click)="generatePrintFile()"
          >
            Generar ficheros
          </button>
        </div>
      </div>
    </div>
  </div>
  <button class="formButtonBack mt-3 ml-3" *ngIf="!userConcesionario" [ngStyle]="{ 'line-height': '0.8', 'font-size': '17px' }" (click)="exportToExcel()">
    <em class="fas fa-file-excel"></em>
  </button>
</div>
